import { workCategorySchema } from '@/api/fetch-for-works-with-filter.ts'
import { ActionsButtons } from '@/routes/_app/works/-components/actions-buttons.tsx'
import { WorkGallery } from '@/routes/_app/works/-components/workGallery.tsx'
import { WorksFilter } from '@/routes/_app/works/-components/works-filter.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const worksFiltersSchema = z.object({
  name: fallback(z.string().nullable(), ''),
  status: fallback(z.enum(['read', 'unread', 'finished', 'favorites']).nullable(), null),
  category: fallback(workCategorySchema.nullable(), null),
  tagId: fallback(z.string().nullable().optional(), null),
})

export const Route = createFileRoute('/_app/works/')({
  component: RouteComponent,
  validateSearch: zodValidator(worksFiltersSchema),

  head: () => ({
    meta: [
      {
        title: 'Minhas Obras | Okami',
      },
    ],
  }),
})

function RouteComponent() {
  return (
    <>
      <div className=" flex flex-col gap-4">
        <h1 className="text-center text-3xl font-bold tracking-tighter md:text-left">Minhas Obras</h1>

        <aside className="flex flex-col items-center  gap-2 md:flex-row md:justify-between ">
          <WorksFilter />

          <ActionsButtons />
        </aside>

        <WorkGallery />
      </div>
    </>
  )
}
